let marmosetLoaded = false
let marmosetLoading = false
const pendingContainers = []
const viewerInstances = new WeakMap()

function loadMarmosetScript() {
  return new Promise((resolve, reject) => {
    if (marmosetLoaded) {
      resolve()
      return
    }

    if (marmosetLoading) {
      pendingContainers.push({ resolve, reject })
      return
    }

    marmosetLoading = true

    const script = document.createElement('script')
    script.src = 'https://viewer.marmoset.co/main/marmoset.js'

    script.onload = () => {
      marmosetLoaded = true
      marmosetLoading = false
      resolve()
      pendingContainers.forEach((pending) => pending.resolve())
      pendingContainers.length = 0
    }

    script.onerror = () => {
      marmosetLoading = false
      const error = new Error('Failed to load Marmoset viewer')
      reject(error)
      pendingContainers.forEach((pending) => pending.reject(error))
      pendingContainers.length = 0
    }

    document.head.appendChild(script)
  })
}

function createViewer(container) {
  const mviewUrl = container.dataset.mviewUrl
  if (!mviewUrl) {
    showError(container, 'No 3D file available')
    return
  }

  const skeleton = container.querySelector('.embed__skeleton')

  // Disable UI controls (fullscreen, help, layer views, etc.)
  window.marmoset.noUserInterface = true

  try {
    const viewer = new window.marmoset.WebViewer(
      container.clientWidth,
      container.clientHeight,
      mviewUrl
    )

    viewer.onLoad = () => {
      if (skeleton) skeleton.remove()
      container.setAttribute('data-loaded', 'true')
    }

    viewer.onError = () => {
      showError(container, '3D viewer unavailable')
    }

    container.appendChild(viewer.domRoot)

    // Auto-start the viewer so user can interact without clicking play
    if (viewer.loadScene && typeof viewer.loadScene === 'function') {
      viewer.loadScene()
    }

    // Store viewer instance for resize handling
    viewerInstances.set(container, viewer)

    // Add ResizeObserver to handle viewport changes
    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (!entry) return

      const { width, height } = entry.contentRect
      if (width > 0 && height > 0 && viewer.resize) {
        viewer.resize(width, height)
      }
    })
    resizeObserver.observe(container)
  } catch {
    showError(container, '3D viewer unavailable')
  }
}

function showError(container, message) {
  const skeleton = container.querySelector('.embed__skeleton')
  if (skeleton) skeleton.remove()

  const errorDiv = document.createElement('div')
  errorDiv.className = 'embed__error'
  errorDiv.textContent = message
  container.appendChild(errorDiv)
}

export function initMarmosetViewer(container) {
  if (container.dataset.loaded === 'true') return

  loadMarmosetScript()
    .then(() => createViewer(container))
    .catch(() => {
      showError(container, '3D viewer unavailable')
    })
}
